const file         = require ('../components/file/file')

export const obj = {
   
    file:          { start: function(detail){ file.start(detail)}},
}


